"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPartyFinderDocument = instanceOfPartyFinderDocument;
exports.PartyFinderDocumentFromJSON = PartyFinderDocumentFromJSON;
exports.PartyFinderDocumentFromJSONTyped = PartyFinderDocumentFromJSONTyped;
exports.PartyFinderDocumentToJSON = PartyFinderDocumentToJSON;
exports.PartyFinderDocumentToJSONTyped = PartyFinderDocumentToJSONTyped;
var JoinRestriction_1 = require("./JoinRestriction");
var ReferencedDisplay_1 = require("./ReferencedDisplay");
var EntityRef_1 = require("./EntityRef");
var FullUserDisplay_1 = require("./FullUserDisplay");
var IdentifiableUserMapping_1 = require("./IdentifiableUserMapping");
var DisplayableUserMapping_1 = require("./DisplayableUserMapping");
var StringIconicDisplay_1 = require("./StringIconicDisplay");
/**
 * Check if a given object implements the PartyFinderDocument interface.
 */
function instanceOfPartyFinderDocument(value) {
    return true;
}
function PartyFinderDocumentFromJSON(json) {
    return PartyFinderDocumentFromJSONTyped(json, false);
}
function PartyFinderDocumentFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'reference': json['reference'] == null ? undefined : (0, EntityRef_1.EntityRefFromJSON)(json['reference']),
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'user': json['user'] == null ? undefined : (0, FullUserDisplay_1.FullUserDisplayFromJSON)(json['user']),
        'lastActiveDate': json['lastActiveDate'] == null ? undefined : (new Date(json['lastActiveDate'])),
        'games': json['games'] == null ? undefined : (json['games'].map(StringIconicDisplay_1.StringIconicDisplayFromJSON)),
        'audience': json['audience'] == null ? undefined : (json['audience'].map(ReferencedDisplay_1.ReferencedDisplayFromJSON)),
        'membersCount': json['membersCount'] == null ? undefined : json['membersCount'],
        'membersMax': json['membersMax'] == null ? undefined : json['membersMax'],
        'joinRestriction': json['joinRestriction'] == null ? undefined : (0, JoinRestriction_1.JoinRestrictionFromJSON)(json['joinRestriction']),
        'participation': json['participation'] == null ? undefined : (json['participation'].map(DisplayableUserMapping_1.DisplayableUserMappingFromJSON)),
        'dateActive': json['dateActive'] == null ? undefined : (new Date(json['dateActive'])),
        '_participating': json['_participating'] == null ? undefined : (0, DisplayableUserMapping_1.DisplayableUserMappingFromJSON)(json['_participating']),
        '_applied': json['_applied'] == null ? undefined : (0, IdentifiableUserMapping_1.IdentifiableUserMappingFromJSON)(json['_applied']),
        '_invited': json['_invited'] == null ? undefined : (0, IdentifiableUserMapping_1.IdentifiableUserMappingFromJSON)(json['_invited']),
    };
}
function PartyFinderDocumentToJSON(json) {
    return PartyFinderDocumentToJSONTyped(json, false);
}
function PartyFinderDocumentToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'reference': (0, EntityRef_1.EntityRefToJSON)(value['reference']),
        'id': value['id'],
        'name': value['name'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString()),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString()),
        'user': (0, FullUserDisplay_1.FullUserDisplayToJSON)(value['user']),
        'lastActiveDate': value['lastActiveDate'] == null ? undefined : ((value['lastActiveDate']).toISOString()),
        'games': value['games'] == null ? undefined : (value['games'].map(StringIconicDisplay_1.StringIconicDisplayToJSON)),
        'audience': value['audience'] == null ? undefined : (value['audience'].map(ReferencedDisplay_1.ReferencedDisplayToJSON)),
        'membersCount': value['membersCount'],
        'membersMax': value['membersMax'],
        'joinRestriction': (0, JoinRestriction_1.JoinRestrictionToJSON)(value['joinRestriction']),
        'participation': value['participation'] == null ? undefined : (value['participation'].map(DisplayableUserMapping_1.DisplayableUserMappingToJSON)),
        'dateActive': value['dateActive'] == null ? undefined : ((value['dateActive']).toISOString()),
        '_participating': (0, DisplayableUserMapping_1.DisplayableUserMappingToJSON)(value['_participating']),
        '_applied': (0, IdentifiableUserMapping_1.IdentifiableUserMappingToJSON)(value['_applied']),
        '_invited': (0, IdentifiableUserMapping_1.IdentifiableUserMappingToJSON)(value['_invited']),
    };
}
